import { render, staticRenderFns } from "./ModalModels.vue?vue&type=template&id=7125f7cf&"
import script from "./ModalModels.vue?vue&type=script&lang=js&"
export * from "./ModalModels.vue?vue&type=script&lang=js&"
import style0 from "./ModalModels.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports